import { diagnosticsApi, type DxDepartmentDto } from "@/api/diagnostics";
import { MasterListPage } from "./MasterListPage";
import { MasterFormPage } from "./MasterFormPage";
import { statusColumn, TextFieldCell, SwitchCell } from "./fields";

const BASE = "/diagnostics/departments";
const LIST_KEY = ["dx-departments"];

export function DiagnosticsDepartmentsPage() {
  return (
    <MasterListPage<DxDepartmentDto>
      breadcrumbs={["Diagnostics", "Masters"]}
      title="Departments"
      subtitle="Top-level grouping for the lab catalog."
      queryKey={LIST_KEY}
      listFn={(inc) => diagnosticsApi.listDepartments(inc)}
      deleteFn={diagnosticsApi.deleteDepartment}
      basePath={BASE}
      newLabel="New department"
      labelOf={(r) => r.name}
      deleteNote="It will be refused while any test category, lab test, profile or facility still belongs to it."
      columns={[
        { field: "code", headerName: "Code", width: 160 },
        { field: "name", headerName: "Name", flex: 1, minWidth: 240 },
        statusColumn<DxDepartmentDto>(),
      ]}
    />
  );
}

interface Values { code: string; name: string; isActive: boolean }

export function DepartmentFormPage() {
  return (
    <MasterFormPage<Values, DxDepartmentDto>
      breadcrumbs={["Diagnostics", "Departments"]}
      noun="department"
      basePath={BASE}
      listQueryKey={LIST_KEY}
      detailQueryKey={(id) => ["dx-department", id]}
      defaultValues={{ code: "", name: "", isActive: true }}
      getFn={diagnosticsApi.getDepartment}
      toValues={(d) => ({ code: d.code, name: d.name, isActive: d.isActive })}
      createFn={(v) => diagnosticsApi.createDepartment({ code: v.code.trim(), name: v.name.trim() })}
      updateFn={(id, v) => diagnosticsApi.updateDepartment(id, {
        code: v.code.trim(), name: v.name.trim(), isActive: v.isActive,
      })}
    >
      {({ control }, isEdit) => (
        <>
          <TextFieldCell control={control} name="code" label="Code" span={4} required />
          <TextFieldCell control={control} name="name" label="Name" span={8} required />
          {isEdit && <SwitchCell control={control} name="isActive" label="Active" />}
        </>
      )}
    </MasterFormPage>
  );
}
